import CaseStudyTwoContainer from "./containers/CaseStudyTwoContainer";
export default CaseStudyTwoContainer;
